import {createFeatureSelector, createSelector} from "@ngrx/store";
import {AccountState} from "./account.state";
import {SchoolGroupStatus} from "@core/models/domain/group.domain";
import {isRemovedUser} from "@core/utils/user-status.util";

export const selectAccountState = createFeatureSelector<AccountState>('account');

export const selectAllUsers = createSelector(
    selectAccountState,
    (state) => state.users
);

// Memoized list view: users not removed from the school, with only their ACTIVE groups.
// A pupil shown INACTIVE only because no device is enrolled stays in the list.
// Computed once per state change instead of in every consuming component.
export const selectActiveUsers = createSelector(
    selectAllUsers,
    (users) => users
        .filter(user => !isRemovedUser(user))
        .map(user => ({
            ...user,
            schoolGroups: user.schoolGroups?.filter(
                group => group.status === SchoolGroupStatus.ACTIVE
            ) || []
        }))
);

export const selectSchoolInfo = createSelector(
    selectAccountState,
    (state) => state.schoolInfo
);

export const selectUserLoading = createSelector(
    selectAccountState,
    (state) => state.userLoading
);

export const selectUserError = createSelector(
    selectAccountState,
    (state) => state.userError
);

export const selectSchoolLoading = createSelector(
    selectAccountState,
    (state) => state.schoolLoading
);

export const selectSchoolError = createSelector(
    selectAccountState,
    (state) => state.schoolError
);

export const selectIntegrationSchoolSyncLoading = createSelector(
    selectAccountState,
    (state) => state.integrationSchoolSyncLoading
);

export const selectIntegrationSchoolSyncError = createSelector(
    selectAccountState,
    (state) => state.integrationSchoolSyncError
);

export const selectIntegrationSchoolSyncResult = createSelector(
    selectAccountState,
    (state) => state.integrationSchoolSyncResult
);

export const selectIntegrationSyncStartedDatetime = createSelector(
    selectAccountState,
    (state) => state.integrationSyncStartedDatetime
);

export const selectSyncModeSaving = createSelector(
    selectAccountState,
    (state) => state.syncModeSaving
);

export const selectSyncModeError = createSelector(
    selectAccountState,
    (state) => state.syncModeError
);

export const selectUser = (userAccountId: string) =>
  createSelector(selectAllUsers, users => users.find(g => g.userInfo.accountId === userAccountId));

export const selectDeactivatingSchool = createSelector(
    selectAccountState,
    (state) => state.deactivatingSchool
);

export const selectDeactivateSchoolError = createSelector(
    selectAccountState,
    (state) => state.deactivateSchoolError
);
